import React, { memo } from 'react'
import { useDroppable } from "@dnd-kit/core";

export const Trash = memo(function Trash(props) {
  const { containerType } = props;

  // Only profile items and trash should be droppable
  const { isOver, setNodeRef } = useDroppable({ id: containerType });

  return (
    <div ref={setNodeRef} className={"pm-trash d-flex" + (isOver ? ' over' : '')}>
      <div className="m-2">Drag profile items here to remove them: </div>
      <div className="pm-trash-img m-2"></div>
    </div>
  )
});